import React from 'react'
import AuthLayout from '../../components/layouts/auth_layout'
import MainBackground from '../../images/main_bg.png'
import FlatButton from '../../components/buttons/flat_button'
import { useNavigate } from 'react-router-dom'

const RegisterMailSendCompletePage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <AuthLayout>
      <div
        className="min-h-screen flex flex-col justify-center items-center bg-cover bg-center bg-no-repeat p-4"
        style={{
          backgroundImage: `url(${MainBackground})`,
        }}
      >
        <div className="bg-white rounded-xl py-8 px-8 w-full max-w-lg">
          <h1 className="text-2xl font-bold text-center mb-6">
            メール送信完了
          </h1>
          <div className="space-y-2 mb-6">
            <p>このたびは、会員登録をして頂き誠にありがとうございます。</p>
            <p>
              ご記入いただいたメールアドレスへ、メールアドレス認証のための確認メールをお送りしております。
            </p>
            <p>
              メール本文記載のURLからアクセスし、会員登録を完了させてください。
            </p>
          </div>
          <FlatButton className="w-full" onClick={() => navigate('/login')}>
            ログインページへ戻る
          </FlatButton>
        </div>
      </div>
    </AuthLayout>
  )
}

export default RegisterMailSendCompletePage
